import { ToastIntent, ToastPosition, useToastController } from '@fluentui/react-components';
import React from 'react';
import { CustomToast } from '../../pages/shared-components/CustomToast';

export const APP_TOASTER_ID = 'app-toaster';

interface ShowToastOptions {
  title: string | React.JSX.Element;
  intent?: ToastIntent;
  position?: ToastPosition;
}

export const useAppToast = () => {
  const { dispatchToast } = useToastController(APP_TOASTER_ID);

  const showToast = ({
    title,
    intent = 'info',
    position = 'top',
  }: ShowToastOptions): void => {
    dispatchToast(
      <CustomToast
        title={title}
      />,
      {
        intent,
        position,
      },
    );
  };

  return { showToast };
};
